module.exports = __webpack_public_path__ + "static/media/Tertiary.cadd9f9f.png";